import {useMutation} from "@apollo/client";
import {useState} from "react";
import {FiTrash} from "react-icons/fi";

import {Icon} from "@/components/icon/Icon.tsx";
import {ActionDialog} from "@/components/overlay/ActionDialog.tsx";
import {TableCrownButton} from "@/components/tableCrownButton/TableCrownButton.tsx";
import {GQL_DELETE_TAGS, GQL_SERVICE_TAGS} from "@/lib/queries/checks.ts";
import {GraphQLResponse, ResponseStatus} from "@/lib/types/common.ts";

interface TagsBulkActionDeleteProps {
  selectedItemsIds: number[];
  onSuccess: () => void;
}

export const TagsBulkActionDelete = ({selectedItemsIds, onSuccess}: TagsBulkActionDeleteProps) => {
  const [show, setShow] = useState<boolean>(false);
  const [deleteTags, {loading}] = useMutation<GraphQLResponse<null>>(GQL_DELETE_TAGS, {
    refetchQueries: [GQL_SERVICE_TAGS],
  });

  const handleSubmit = async () => {
    const response = await deleteTags({
      variables: {
        ids: selectedItemsIds,
      },
    });

    if (response.data?.response.status === ResponseStatus.SUCCESS) {
      setShow(false);
      onSuccess();
    }
  };

  return (
    <>
      <TableCrownButton onClick={() => setShow(true)}>
        <Icon icon={FiTrash} />
        Delete Tags
      </TableCrownButton>
      <ActionDialog
        show={show}
        loading={loading}
        title="Delete Multiple Tags"
        onConfirm={handleSubmit}
        onCancel={() => setShow(false)}
      >
        <div>
          <div className="row mb-4">
            <div className="col">Are you sure you want to delete {selectedItemsIds.length} Tags?</div>
          </div>
        </div>
      </ActionDialog>
    </>
  );
};
